module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-full",
    class: _vm.classLanceOnline
  }, [_c('div', {
    staticClass: "pregao-botoes h-full",
    class: {
      'isLoading': _vm.isLoading
    }
  }, [_c('div', {
    staticClass: "header-info0"
  }, [_c('div', {
    staticClass: "lote-num-label"
  }, [_c('div', {
    staticClass: "lote-numero"
  }, [_vm._v("Lote " + _vm._s(_vm.lote.numero)), _c('div', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['enter']),
      expression: "['enter']"
    }],
    staticClass: "no-select",
    on: {
      "shortkey": _vm.efetuarLance
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "leilao-nome"
  }, [_vm._v(_vm._s(_vm.leilao.titulo))]), _vm._v(" "), _c('div', {
    staticClass: "errors"
  }, [_c('div', {
    staticClass: "erros-title"
  }, [_vm._v("Respostas/Erros")]), _vm._v(" "), _c('div', {
    staticClass: "erros-content"
  }, [_vm._v(_vm._s(_vm.errors))])])])]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.processandoLance
    },
    on: {
      "click": _vm.efetuarLance
    }
  }, [(_vm.processandoLance) ? _c('span', [_vm._v("Processando lance...")]) : _c('span', [_vm._v("Lance")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12578b3a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/pregao-botoes/Main.vue
// module id = 899
// module chunks = 1